module.exports = __webpack_public_path__ + "img/pop_msg.1aaf58f7.png";